import * as React from 'react';
import autobind from 'autobind-decorator';

import { UserListDataService } from 'src/app/general/users/list/user-list.data';
import { UserEditorView } from './user-editor.view';

interface UserEditorControllerProps {
	mode: ControlMode;
	label?: string;
	value: number | null;
	onChanged?: (value: UserSummary | null) => void;
	isRole?: boolean;
	setBusy: (isBusy: boolean) => void;
	required?: boolean;
	readOnly?: boolean;
	selectFirst?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class UserEditorController extends React.Component<UserEditorControllerProps, any> {
	protected userDataService: UserListDataService;

	constructor(props) {
		super(props);
		this.userDataService = UserListDataService.make();
		this.state = {
			initialValue: null
		}
	}

	@autobind
	protected userQuery(q?: string): Promise<QueryResult<UserSummary>> {
		return new Promise<QueryResult<UserSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.userDataService.addFilter('isDeleted', 'eq', false);
			if (this.props.isRole != null || this.props.isRole != undefined)
				this.userDataService.addFilter('isRole', 'eq', this.props.isRole);
			this.userDataService.addSorting('userName', 'asc', true);
			this.userDataService.searchKeywords = q;
			this.userDataService.load(query => query)
				.then((items) => {
					this.props.setBusy(false);

					if (this.props.selectFirst && items.length > 0) {
						this.props.onChanged(items[0]);
						this.setState({
							initialValue: items[0].id
						});
					}

					resolve({
						items: items,
						totalCount: this.userDataService.count
					});
				});
		});
	}

	render() {
		return (
			<UserEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				userRequest={{ query: this.userQuery, dataSet: this.userDataService }}
				onChanged={this.props.onChanged}
				value={this.state.initialValue ? this.state.initialValue : this.props.value}
				label={this.props.label}
				mode={this.props.mode}
				readOnly={this.props.readOnly}
				required={this.props.required}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/parts/user-editor.controller.tsx